import moment from "moment";

// Pakistan Standard Time is a fixed UTC+5 offset (no daylight saving), so a
// plain numeric offset is enough - no need for the moment-timezone package.
const PAKISTAN_UTC_OFFSET_MINUTES = 5 * 60;

/**
 * Parses a date/time value (as returned by the Laravel backend, e.g.
 * "2026-08-02T09:02:27.000000Z") and returns a moment object fixed to
 * Pakistan Standard Time (UTC+5).
 *
 * We force the PKT offset explicitly instead of relying on the browser/
 * device's own timezone setting, so times display correctly and
 * consistently everywhere this app runs (reception desk PC, kitchen
 * tablet, etc.) regardless of how each device's clock/locale is configured.
 */
const toPakistanTime = (value) => moment.utc(value).utcOffset(PAKISTAN_UTC_OFFSET_MINUTES);

/**
 * Formats a date/time value as date + time with AM/PM, in Pakistan time.
 * e.g. "02-08-2026, 02:02 PM". Returns an empty string for missing values,
 * and the original value unchanged if it can't be parsed as a date.
 */
export const formatDateTime = (value) => {
  if (!value) return "";
  const parsed = toPakistanTime(value);
  return parsed.isValid() ? parsed.format("DD-MM-YYYY, hh:mm A") : value;
};

/**
 * Same as formatDateTime but also includes seconds, for contexts (like an
 * order feed) where second-level precision is useful.
 * e.g. "02-08-2026, 02:02:27 PM".
 */
export const formatDateTimeWithSeconds = (value) => {
  if (!value) return "";
  const parsed = toPakistanTime(value);
  return parsed.isValid() ? parsed.format("DD-MM-YYYY, hh:mm:ss A") : value;
};
